import { useState } from "react";
import { Link } from "react-router-dom";
import { productUrl } from "../../data/catalog";
import { FadeUp, MaskLines } from "../site/Reveal";

const WAYS = [
  { id: "crossbody", title: "Crossbody", text: "Across the chest for quick access on the go.", img: "/img/look-blush-a.webp", color: "blush" },
  { id: "waist", title: "At the waist", text: "The classic hands-free carry, sitting clean at the front.", img: "/img/look-black-b.webp", color: "black" },
  { id: "shoulder", title: "Over the shoulder", text: "Slung over one shoulder for an easy, relaxed drape.", img: "/img/look-burgundy-b.webp", color: "burgundy" },
  { id: "hand", title: "In hand", text: "Strap tucked away, carried like a clutch.", img: "/img/look-olive-a.webp", color: "olive" },
];

export const WearItYourWay = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="bg-night py-24 text-ivory md:py-36" data-testid="wear-it-your-way">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="mb-12 flex flex-col justify-between gap-6 md:mb-16 md:flex-row md:items-end">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#A1A1A6]">Four ways to wear</p>
            <MaskLines inView lines={["Wear it", <em key="w">your way.</em>]} className="mt-4 font-display text-5xl font-light leading-[0.92] md:text-7xl lg:text-8xl" />
          </div>
          <FadeUp className="max-w-sm text-sm leading-relaxed text-[#C9C9CC]">One adjustable strap, four ways to carry. Tap a look to shop that color.</FadeUp>
        </div>
        <FadeUp className="-mx-5 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 md:mx-0 md:h-[640px] md:overflow-visible md:px-0 md:pb-0">
          {WAYS.map((w, i) => (
            <Link key={w.id} to={productUrl(w.color)} onMouseEnter={() => setActive(i)} data-testid={`wear-way-${w.id}`}
              className={`group relative aspect-[3/4] w-[78vw] shrink-0 snap-start overflow-hidden transition-[flex-grow] duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] sm:w-[46vw] md:aspect-auto md:w-auto md:shrink ${active === i ? "md:flex-[3.2]" : "md:flex-1"}`}>
              <img src={w.img} alt={`MARKHOR belt bag worn ${w.title.toLowerCase()}`} loading="lazy" className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-[1.2s] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <span className="absolute left-5 top-5 font-mono text-[11px] text-white/90">0{i + 1}</span>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <p className="font-display text-3xl text-white">{w.title}</p>
                <p className={`mt-2 max-w-xs text-sm text-[#E4E4E6] transition-opacity duration-500 ${active === i ? "md:opacity-100" : "md:opacity-0"}`}>{w.text}</p>
              </div>
            </Link>
          ))}
        </FadeUp>
      </div>
    </section>
  );
};
